<template>
  <!-- 停车场黑名单 -->
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">停车场黑名单</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label>
          <el-select v-model="filterForm.parkNo" placeholder="请选择停车场名称" filterable clearable>
            <el-option
              v-for="item in parkList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select
            v-model="filterForm.carLicensePlateNo"
            placeholder="请选择车牌号"
            filterable
            clearable
          >
            <el-option v-for="item in carNoList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.operationTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.operationStaffName" placeholder="操作人" filterable clearable>
            <el-option
              v-for="item in addUserList"
              :key="item.staffId"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filterForm.operationType" clearable placeholder="操作类型">
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table :data="carBlackList" stripe size="mini" style="width: 100%" row-key="id">
      <el-table-column type="index" width="50" align="center" fixed label="序号"></el-table-column>
      <el-table-column prop="parkName" align="center" label="停车场名称"></el-table-column>
      <el-table-column prop="driverManagerPhone" align="center" label="司机管理手机号"></el-table-column>
      <el-table-column prop="carLicensePlateNo" align="center" label="车牌号"></el-table-column>
      <el-table-column prop="operationTimeStr" align="center" label="操作时间"></el-table-column>
      <el-table-column prop="operationStaffName" align="center" label="操作人"></el-table-column>
      <el-table-column prop="operationTypeName" align="center" width="150" label="操作类型"></el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding: 20px">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";

export default {
  components: {
    KtButton
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      filterTime: [],
      carBlackList: [],
      parkList: [],
      carNoList: [],
      addUserList: [],
      typeList: [],
      filterForm: {
        parkNo: "",
        carLicensePlateNo: "",
        operationTime: "",
        operationStaffName: "",
        operationType: ""
      }
    };
  },
  mounted() {
    this.getCarBlackList();
    this.getParkList();
    this.getCarNoList();
    this.getAddUserList();
    this.getOperationTypeList();
  },
  methods: {
    // 获取停车场黑名单列表
    async getCarBlackList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "operationTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.blacklist.mGetParkBlackList(params);
      this.totalSize = res.data.totalSize;
      if (res.data && res.data.dtoList && res.data.dtoList.length > 0) {
        this.carBlackList = res.data.dtoList;
      } else {
        this.carBlackList = [];
      }
    },

    // 获取所有的停车场下拉
    async getParkList() {
      let res = await this.$api.blacklist.mGetParkList();
      if (res.data && res.data.length) {
        this.parkList = res.data;
      } else {
        this.parkList = [];
      }
    },

    // 获取下拉车牌号列表
    async getCarNoList() {
      let res = await this.$api.blacklist.mGetCarLicensePlateNoList();
      if (res.data && res.data.length) {
        this.carNoList = res.data;
      } else {
        this.carNoList = [];
      }
    },

    // 获取操作人
    async getAddUserList() {
      this.$api.system.mSelectCoalMineNoStaff().then(res => {
        if (res.data && res.data.length > 0) {
          this.addUserList = res.data;
        } else {
          this.addUserList = [];
        }
      });
    },

    // 获取操作类型
    async getOperationTypeList() {
      let res = await this.$api.blacklist.mGetOperationTypeList();
      if (res.data && res.data.length > 0) {
        this.typeList = res.data;
      } else {
        this.typeList = [];
      }
    },

    // 换页刷新和搜索
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getCarBlackList();
    },

    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getCarBlackList();
    },

    // 重置
    handleReset() {
      this.filterForm = {
        parkNo: "",
        carLicensePlateNo: "",
        operationTime: "",
        operationStaffName: "",
        operationType: ""
      };
      this.handleSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}

.dialogDesc {
  text-align: center;
  font-weight: 600;
}
</style>
